<rr-icon name="user" class="default-company" *ngIf="
    !company.logo &&
    (
        !company.name ||
        company.name === ''
    ) &&
    !base64
  ">
</rr-icon>
<div class="default-company tiny" *ngIf="!company.logo && (company.name?.length)">
    {{ company.name![0] }}{{ company.name!.length > 1 ? company.name![1] : ''}}
</div>
<img class="logo" *ngIf="company.logo" [src]="serverurl + '/companies/logo/' + company.companyId + '?' + company.refreshToken"
    alt="Company Logo" />
<img *ngIf="base64" [src]="base64" class="logo">

